module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7437/images/default-avatar.png"